(function () {
  'use strict';

  /* ---------------------------------------------------------------
     Mobile nav toggle (header burger)
  --------------------------------------------------------------- */
  var burger = document.querySelector('[data-dc-nav-toggle]');
  var mobileNav = document.querySelector('[data-dc-mobile-nav]');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      var isHidden = mobileNav.hasAttribute('hidden');
      if (isHidden) {
        mobileNav.removeAttribute('hidden');
        burger.setAttribute('aria-expanded', 'true');
      } else {
        mobileNav.setAttribute('hidden', '');
        burger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------------------------------------------------------------
     Cart count helper — used after any /cart/add.js call
  --------------------------------------------------------------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-dc-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  /* ---------------------------------------------------------------
     Build-your-box product form
  --------------------------------------------------------------- */
  var builder = document.querySelector('[data-dc-box-builder]');
  if (builder) {
    var sizeTiles = Array.prototype.slice.call(builder.querySelectorAll('[data-dc-size-tile]'));
    var flavourRows = Array.prototype.slice.call(builder.querySelectorAll('[data-dc-flavour-row]'));
    var freqTiles = Array.prototype.slice.call(builder.querySelectorAll('[data-dc-freq-tile]'));
    var countLabel = builder.querySelector('[data-dc-flavour-count]');
    var totalLabel = builder.querySelector('[data-dc-total]');
    var ctaBtn = builder.querySelector('[data-dc-cta]');
    var shipNote = builder.querySelector('[data-dc-ship-note]');
    var variantInput = builder.querySelector('[data-dc-variant-input]');
    var form = builder.querySelector('[data-dc-buildbox-form]');
    var boxShotLabel = builder.querySelector('[data-dc-box-shot-label]');

    var state = { capacity: 4, price: 0, variantId: null, sub: false, sellingPlanId: null };

    function activeSizeTile() {
      return sizeTiles.filter(function (t) { return t.hasAttribute('data-active'); })[0] || sizeTiles[0];
    }

    function readSizeTile(tile) {
      if (!tile) return;
      state.capacity = parseInt(tile.getAttribute('data-capacity'), 10) || 4;
      state.price = parseFloat(tile.getAttribute('data-price')) || 0;
      state.variantId = tile.getAttribute('data-variant-id');
      if (variantInput && state.variantId) variantInput.value = state.variantId;
      if (boxShotLabel) boxShotLabel.textContent = '[ ' + state.capacity + '-cookie box, cream + red ]';
    }

    function resetFlavours() {
      flavourRows.forEach(function (row) {
        setRowCount(row, 0);
      });
    }

    function setRowCount(row, count) {
      var countEl = row.querySelector('[data-dc-flavour-count-value]');
      countEl.textContent = count;
      if (count > 0) {
        row.setAttribute('data-picked', '');
        countEl.setAttribute('data-picked', '');
      } else {
        row.removeAttribute('data-picked');
        countEl.removeAttribute('data-picked');
      }
    }

    function pickedTotal() {
      return flavourRows.reduce(function (sum, row) {
        return sum + (parseInt(row.querySelector('[data-dc-flavour-count-value]').textContent, 10) || 0);
      }, 0);
    }

    function render() {
      var picked = pickedTotal();
      var full = picked === state.capacity;

      if (countLabel) {
        countLabel.textContent = picked + '/' + state.capacity;
        if (full) countLabel.setAttribute('data-full', ''); else countLabel.removeAttribute('data-full');
      }

      flavourRows.forEach(function (row) {
        var plus = row.querySelector('[data-dc-flavour-inc]');
        if (plus) plus.disabled = picked >= state.capacity;
        var minus = row.querySelector('[data-dc-flavour-dec]');
        if (minus) minus.disabled = parseInt(row.querySelector('[data-dc-flavour-count-value]').textContent, 10) === 0;
      });

      var discount = full && state.sub ? (parseFloat(builder.getAttribute('data-discount')) || 10) : 0;
      var total = state.price * (1 - discount / 100);
      if (totalLabel) totalLabel.textContent = '$' + total.toFixed(2);

      if (ctaBtn) {
        if (full) {
          ctaBtn.disabled = false;
          ctaBtn.textContent = 'Add to cart';
          ctaBtn.classList.remove('dc-btn--disabled');
        } else {
          ctaBtn.disabled = true;
          ctaBtn.textContent = 'Pick ' + (state.capacity - picked) + ' more';
          ctaBtn.classList.add('dc-btn--disabled');
        }
      }

      if (shipNote) {
        shipNote.textContent = state.sub
          ? 'Free shipping · dispatched Tuesday'
          : 'Shipping from $8 · free over $70';
      }
    }

    sizeTiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        sizeTiles.forEach(function (t) {
          t.removeAttribute('data-active');
          t.setAttribute('aria-pressed', 'false');
        });
        tile.setAttribute('data-active', '');
        tile.setAttribute('aria-pressed', 'true');
        readSizeTile(tile);
        resetFlavours();
        render();
      });
    });

    flavourRows.forEach(function (row) {
      var inc = row.querySelector('[data-dc-flavour-inc]');
      var dec = row.querySelector('[data-dc-flavour-dec]');
      if (inc) inc.addEventListener('click', function () {
        var countEl = row.querySelector('[data-dc-flavour-count-value]');
        var current = parseInt(countEl.textContent, 10) || 0;
        if (pickedTotal() >= state.capacity) return;
        setRowCount(row, current + 1);
        render();
      });
      if (dec) dec.addEventListener('click', function () {
        var countEl = row.querySelector('[data-dc-flavour-count-value]');
        var current = parseInt(countEl.textContent, 10) || 0;
        setRowCount(row, Math.max(0, current - 1));
        render();
      });
    });

    freqTiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        freqTiles.forEach(function (t) { t.removeAttribute('data-active'); });
        tile.setAttribute('data-active', '');
        state.sub = tile.getAttribute('data-dc-freq-tile') === 'sub';
        state.sellingPlanId = tile.getAttribute('data-selling-plan-id') || null;
        render();
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (pickedTotal() !== state.capacity || !state.variantId) return;

        var properties = {};
        flavourRows.forEach(function (row) {
          var count = parseInt(row.querySelector('[data-dc-flavour-count-value]').textContent, 10) || 0;
          if (count > 0) properties[row.getAttribute('data-flavour-name')] = count;
        });

        var payload = {
          items: [{
            id: state.variantId,
            quantity: 1,
            properties: properties
          }]
        };
        if (state.sub && state.sellingPlanId) {
          payload.items[0].selling_plan = state.sellingPlanId;
        }

        ctaBtn.disabled = true;
        ctaBtn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (res) { return res.json(); })
          .then(function () { return fetch('/cart.js'); })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            render();
          })
          .catch(function () {
            render();
          });
      });
    }

    var initialTile = activeSizeTile();
    readSizeTile(initialTile);
    render();
  }
})();
